import { render, staticRenderFns } from "./ShipmentForecastByDate.vue?vue&type=template&id=5f5332c0&scoped=true&"
import script from "./ShipmentForecastByDate.vue?vue&type=script&lang=ts&"
export * from "./ShipmentForecastByDate.vue?vue&type=script&lang=ts&"
import style0 from "./ShipmentForecastByDate.vue?vue&type=style&index=0&id=5f5332c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5332c0",
  null
  
)

export default component.exports